import { CACHE_KEY_PURCHASE_EVENT_SENT } from '@application/constants';
import { useRouter } from '@application/utils';
import { Analytics } from '@application/utils/analytics';
import { Button, Container, Illustration, Section, SectionText } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { useEffect } from 'react';
import { TbArrowRight } from 'react-icons/tb';
import * as Styled from './styled';
import type { MtApplicationAcceptSuccessPageProps } from './types';

export * from './types';

export const MtApplicationAcceptSuccessPage: FC<MtApplicationAcceptSuccessPageProps> = (props) => {
  const { priceValue } = props;

  const { navigateToRoute } = useRouter();

  const { translate } = useTranslation();
  const { translate: translateResource } = useTranslation({
    keyPrefix: 'mt.buyer.applications.acceptedSuccess',
  });

  useEffect(() => {
    // Prevent double track when user refresh the page
    if (localStorage.getItem(CACHE_KEY_PURCHASE_EVENT_SENT) === 'true' || !priceValue) {
      return;
    }

    Analytics.sendPurchaseEvent(priceValue);
    localStorage.setItem(CACHE_KEY_PURCHASE_EVENT_SENT, 'true');
  }, [priceValue]);

  return (
    <Container>
      <Section centerChildren>
        <Styled.Title color="green">{translateResource('title')}</Styled.Title>

        <Illustration type="puppy-love" />

        <SectionText>{translateResource('text')}</SectionText>

        <Styled.ButtonWrapper>
          <Button
            color="blue"
            onClick={() => navigateToRoute('mtApplications')}
            shrink
            iconRight={<TbArrowRight />}
          >
            {translate('common.buttons.myApplications')}
          </Button>
        </Styled.ButtonWrapper>

        <Styled.SubText dangerouslySetInnerHTML={{ __html: translateResource('subtext') }} />
      </Section>
    </Container>
  );
};
